<template>
  <div>
    <v-row class="pa-10">
      <v-col cols="12">
        <h2 class="primary--text font-weight-bold pt-5 pl-2">
          <v-icon color="primary" large left>
          </v-icon>
          {{ $t('display/pdf:title') }}
        </h2>

        <DataTablePaginated
          ref="table"
          class="ma-1"
          :headers="headers"
          icon="file_download"
          @updateTableData="updateTable"
          sortBy="createdAt"
          sort-desc
          @clickedButton1="downloadPdf"
          @cacheCommit="$store.commit('display/elevator/storePdfOverviewSearch', $event)"
          :cachedSearch="$store.state.display.elevator.pdfOverviewSearch"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>

import DataTablePaginated from '@/modules/core/components/DataTable/DataTablePaginated';
import PdfService from '@/modules/display/services/pdf-service';
import DataUtils from '@/modules/core/services/data-utils';
import Utils from '@/modules/core/services/utils';
import Pdf from '@/modules/display/data/pdf';

export default {
  name: "PdfOverview",
  components: {
    DataTablePaginated
  },
  computed: {
    headers() {
      return [
        {text: this.$t('display/pdf:id'), value: 'id'},
        {text: this.$t('common:name'), value: 'name'},
        {text: this.$t('common:type'), value: 'type'},
        {text: this.$t('common:status'), value: 'status'},
        {text: this.$t('common:customer'), value: 'customerName'},
        {text: this.$t('common:created_at'), value: 'createdAt'},
        {text: "", value: "controls", sortable: false}
      ];
    }
  },
  methods: {
    updateTable(options, search) {

      if (!search) search = '';

      this.$refs.table.loading = true;

      PdfService.readAllPaginatedFromAPI(
        options.page - 1,
        options.itemsPerPage,
        search,
        options.sortBy,
        options.sortDesc,
        (response) => {
          if (this.$refs.table !== undefined) {
            response.data.content = DataUtils.parseDataToObjectArray(response.data.content, Pdf);
            this.$refs.table.fillTableData(response.data);
          }
          this.$refs.table.loading = false;
        },
        (error) => {
          this.$refs.table.loading = false;
          Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('display/pdf:title')}));
          this.$logger.error(error);
        }
      );

    },
    downloadPdf(item) {
      PdfService.downloadPdf(
        item.id,
        (pdfFile) => {
          const link = document.createElement('a');
          link.href = URL.createObjectURL(pdfFile);
          link.download = item.id + '.pdf';
          link.click();
          URL.revokeObjectURL(link.href);
        },
        () => {
          Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('display/pdf:title')}));
        }
      )
    },
  },
  mounted() {
    setInterval(() => {
      let search = this.$store.state.display.elevator.pdfOverviewSearch;

      if (!search || !search.length) {
        this.$refs.table.callTableUpdate();
      }
    }, 5000)
  }
}
</script>
